/**
Project: Voice Panel (c)
Title: Subscriber Reducer
Description: Reducer for the logged-in user
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import {
  SUBSCRIBER_IDENTITY,
  SUBSCRIBER_ACCOUNT,
  SUBSCRIBER_MENUS,
} from "./constants";

const INIT_STATE = {
  subscriberIdentity: null,
  subscriberAccount: null,
  subscriberMenus: [],
};

/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SUBSCRIBER_IDENTITY:
      return {
        ...state,
        subscriberIdentity: action.payload,
      };
    case SUBSCRIBER_ACCOUNT:
      return {
        ...state,
        subscriberAccount: action.payload,
      };
    case SUBSCRIBER_MENUS:
      return {
        ...state,
        subscriberMenus: action.payload,
      };
    default:
      return state;
  }
};
